import React from 'react';
import VideosCards from './VideosCards';
import { ArrowRightOutlined } from '@ant-design/icons';
import { useHistory } from 'react-router-dom';
import SingleVideoCards from './SingleVideoCards';
import { isMobile } from 'react-device-detect';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const settings = {
  dots: true,
  infinite: false,
  speed: 500,
  initialSlide: 0,
  slidesToShow: 1.2,
  slidesToScroll: 1,
  arrows: false,
  responsive: [
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 1.2,
        slidesToScroll: 1,
      },
    },
  ],
};

function VideosSection({ items, orgId }) {
  const history = useHistory();

  const videoCardsElements =
    items.testimonials &&
    items.testimonials.map((testimonialItems, index) => {
      if (!isMobile && items.testimonials.length === 1) {
        return <SingleVideoCards items={testimonialItems} sectionName={items.sectionName} />;
      } else {
        return <VideosCards key={index} items={testimonialItems} sectionName={items.sectionName} />;
      }
    });
  return (
    <div className='videosSectionWrapper'>
      <div className='videosSectionHeading'>
        {!isMobile && items.testimonials.length === 1 ? null : <h1>{items.sectionName}</h1>}
        {items.totalCount && items.totalCount > 8 && (
          <div className='moreVideos moreVideosMobile' onClick={() => history.push(`/${orgId}/${items.id}/${items.sectionName.toLowerCase()}`)}>
            More {items.sectionName}
            <ArrowRightOutlined />
          </div>
        )}
      </div>
      <div className='videosCardsWrapper'>
        {isMobile ? (
          <div className=''>
            <Slider {...settings} className='slickArrows'>
              {videoCardsElements}
            </Slider>
          </div>
        ) : (
          videoCardsElements
        )}
      </div>
      {items.totalCount && items.totalCount > 8 && (
        <div className='moreVideos' onClick={() => history.push(`/${orgId}/${items.id}/${items.sectionName.toLowerCase()}`)}>
          More {items.sectionName}
          <ArrowRightOutlined />
        </div>
      )}
    </div>
  );
}

export default VideosSection;
